module.exports = __webpack_public_path__ + "img/notice.64de6f9e.svg";